export default "__VITE_ASSET__DiqwxTBx__"